import { VenueIncident } from "@/features/treasury/liquidity";

export default function TreasuryLiquidityIncidentPage() {
  return <VenueIncident />;
}